import React from "react";
import { Box, Stack, Typography } from "@mui/material";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
const AwaitingActionList = ({ items }) => (
  <Stack>
    {items.map((item, idx) => (
      <Stack
        key={item.tag}
        direction="row"
        alignItems="center"
        spacing={1.4}
        sx={{
          py: 1.25,
          borderBottom: idx === items.length - 1 ? "none" : "1px solid #e7e2e9",
        }}
      >
        <Box
          sx={{
            width: 30,
            height: 30,
            borderRadius: "8px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexShrink: 0,
            bgcolor: item.danger ? "#fbe6e0" : "#efe7f6",
            color: item.danger ? "#d85a30" : "#4b1f6b",
          }}
        >
          {item.danger ? <WarningAmberIcon fontSize="small" /> : <CheckCircleOutlineIcon fontSize="small" />}
        </Box>
        <Box sx={{ flex: 1 }}>
          <Typography sx={{ fontSize: 13 }}>{item.text}</Typography>
          <Typography sx={{ fontSize: 10.5, color: "text.disabled", fontWeight: 600, textTransform: "uppercase", letterSpacing: "0.04em" }}>
            {item.tag}
          </Typography>
        </Box>
      </Stack>
    ))}
  </Stack>
);

export default AwaitingActionList;
